import localFont from 'next/font/local'

const gillsans = localFont({
  src: [
    {
      path: './fonts/GillSansStd-Light.woff2',
      weight: '300',
      style: 'normal'
    },
    {
      path: './fonts/GillSansStd.woff2',
      weight: '400',
      style: 'normal'
    }
  ]
})

const timesnow = localFont({
  src: [
    {
      path: './fonts/TimesNow-SemiLight.woff2',
      weight: '400',
      style: 'normal'
    }
  ]
})

export type ThemeProps = Partial<{
  fluid: boolean
}>

// eslint-disable-next-line no-unused-vars
const Theme = ({ fluid = true }: ThemeProps) => {
  return (
    <style jsx global>{`
      :root {
        --font-family-gillsans: ${gillsans.style.fontFamily};
        --font-family-timesnow: ${timesnow.style.fontFamily};

        --font-size: ${fluid ? `max(${(10 / 1440) * 100}vw, 10px)` : '10px'};

        --header-height: 8.5rem;
        --header-height-collapsed: 8.5rem;
      }

      @media (min-width: 768px) {
        :root {
          --header-height: 17rem;
          --header-height-collapsed: 10.4rem;
        }
      }
    `}</style>
  )
}

export default Theme
